<template>
  <div>
    <p style="font-weight: bold; color: #df0303; font-size: 1.3rem">
      ATTENTION: Each of the three (3) tasks must be submitted individually to obtain full marks for
      the exam.
    </p>

    <h2 class="mb-4">Introductory Information</h2>

    <v-simple-table>
      <thead>
        <tr v-for="field in fields" :key="field">
          <td style="width: 220px">
            {{ field.name }}
          </td>
          <td>
            <v-text-field v-model="inputs[field.inputKey]" />
          </td>
        </tr>
      </thead>
    </v-simple-table>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';

export default {
  name: 'UOttawa1301ExamCover',
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        title: null,
        author: null,
        demonstrator: null,
        date: null,
      },
      fields: [
        {name: 'Experiment Title: ', inputKey: 'title'},
        {name: 'Author Name: ', inputKey: 'author'},
        {name: "TA's (Demonstrator's) Name: ", inputKey: 'demonstrator'},
        {name: 'Date Experiment Performed: ', inputKey: 'date'},
      ],
    };
  },
};
</script>

<style scoped></style>
